import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface ShopifyProviderProps {
  children: React.ReactNode;
}

export function ShopifyProvider({ children }: ShopifyProviderProps) {
  const location = useLocation();

  useEffect(() => {
    // Ajouter dynamiquement le script App Bridge et la méta balise avec l'API key
    // Cette approche est conforme à la version 4.x de Shopify App Bridge
    const params = new URLSearchParams(location.search);
    const host = params.get('host');
    const shopDomain = params.get('shop');
    const apiKey = import.meta.env.VITE_SHOPIFY_API_KEY || '';

    // Vérifier si les balises existent déjà
    const existingMeta = document.querySelector('meta[name="shopify-api-key"]');
    const existingScript = document.querySelector('script[src="https://cdn.shopify.com/shopifycloud/app-bridge.js"]');

    // Ajouter la méta balise si elle n'existe pas déjà
    if (!existingMeta && apiKey) {
      const metaTag = document.createElement('meta');
      metaTag.name = 'shopify-api-key';
      metaTag.content = apiKey;
      document.head.appendChild(metaTag);
    }

    // Ajouter le script App Bridge en tout premier script (exigence Shopify)
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/app-bridge.js';
      const head = document.head;
      const firstScript = head.querySelector('script');
      if (firstScript) {
        head.insertBefore(script, firstScript);
      } else {
        head.appendChild(script);
      }
    }

    // Stocker les paramètres importants dans le localStorage pour les récupérer ailleurs si nécessaire
    if (host) localStorage.setItem('shopify-host', host);
    if (shopDomain) localStorage.setItem('shopify-shop-domain', shopDomain);

    // Nettoyer lors du démontage du composant
    return () => {
      // Ne pas supprimer les balises pour éviter des problèmes de rechargement
    };
  }, [location.search]);

  return <>{children}</>
}
